import React from "react";

const SignUpForm = ({ handleChange, values, applyFunc }) => {
	return (
        <div className="mt-24 min-h-[60vh] flex items-center justify-center p-4">
			<div className="w-full max-w-sm bg-white dark:bg-gray-900 shadow rounded-lg p-6">
				<form>
					<div className="flex flex-col gap-3">
						<input id="first" placeholder="First Name" value={values.first} onChange={handleChange('first')} className="border rounded px-3 py-2" required />
						<input id="last" placeholder="Last Name" value={values.last} onChange={handleChange('last')} className="border rounded px-3 py-2" required />
						<input id="phone" placeholder="Telephone Number" value={values.phone} onChange={handleChange('phone')} className="border rounded px-3 py-2" />
						<input id="email" type="email" placeholder="Email" value={values.email} onChange={handleChange('email')} className="border rounded px-3 py-2" required />
						<input id="password" type="password" placeholder="Password" value={values.password} onChange={handleChange('password')} className="border rounded px-3 py-2" />
						<input id="passwordconfirm" type="password" placeholder="Confirm Password" value={values.passwordconfirm} onChange={handleChange('passwordconfirm')} className="border rounded px-3 py-2" />
						<button type="button" onClick={applyFunc} className="mt-2 bg-[#880e4f] text-white py-2 rounded">Sign Up</button>
					</div>
				</form>
			</div>
		</div>
    );
}
export default SignUpForm;